export default "__VITE_ASSET__NJrOsgMV__";